const createHistory = require("history").createBrowserHistory;
const history = createHistory({
  forceRefresh: true
})
export default history;